export const getSelectedTabFromHash = ({ hash, bladeId, tabIds, }) => {
    const [bladeAnchor, tabAnchor] = hash.split("--", 2);
    if (bladeAnchor === undefined || tabAnchor === undefined) {
        return undefined;
    }
    if (bladeAnchor.slice(1) !== bladeId) {
        return undefined;
    }
    return tabIds.includes(tabAnchor) ? tabAnchor : undefined;
};
//# sourceMappingURL=getSelectedTabFromHash.js.map